import Page from '@/features/Services/pages/DPA'

export default Page
